module.exports = __webpack_public_path__ + "img/OutubroRosa-Banner-1080x200.a7bd2a88.jpg";